import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import HomePage from "./HomePage";
import MetaImage from "./images/01.png";

import "bootstrap/dist/css/bootstrap.css";
import {
  ThirdwebProvider,
  localWallet,
  zerionWallet,
  frameWallet,
  rainbowWallet,
  trustWallet,
  embeddedWallet,
  phantomWallet,
  coinbaseWallet,
  metamaskWallet,
  walletConnect,
} from "@thirdweb-dev/react";

const activeChain = "polygon";

const root = ReactDOM.createRoot(document.getElementById("root"));

const customMetamaskWallet = metamaskWallet({ recommended: true });
const customCoinbaseWallet = coinbaseWallet();
const customWalletConnect = walletConnect();

customMetamaskWallet.meta.name = "METAPUP WALLET";
//  customMetamaskWallet.meta.iconURL = "/01.png";

customCoinbaseWallet.meta.name = "COINPUP WALLET";
// customCoinbaseWallet.meta.iconURL = "/01.jpg";

customWalletConnect.meta.name = "PUPCONNECT";
// customWalletConnect.meta.iconURL = "/collection.png";

// Render the entire application within the ThirdwebProvider context
root.render(
  <React.StrictMode>
    {window.ethereum ? (
      <ThirdwebProvider
        clientId={process.env.Next_PUBLIC_TEMPLATE_CLIENT_ID}
        activeChain={activeChain}
        supportedWallets={[
          customMetamaskWallet,
          customCoinbaseWallet,
          customWalletConnect,
          phantomWallet(),
          trustWallet(),
          zerionWallet(),
          frameWallet(),
          rainbowWallet(),
        ]}
      >
        <HomePage />
      </ThirdwebProvider>
    ) : (
      <div
        className="flex flex-col items-center justify-center space-y-6"
        style={{ backgroundColor: "white", padding: "20px" }}
      >
        <h1>Sour Pups NFTs</h1>
        <img className="non-web3-image" src={MetaImage} alt="nonweb3" />
        <a
          href="https://metamask.io/download.html"
          target="_blank"
          rel="noopener noreferrer"
          className="text-lg font-bold text-secondary text-black glow-text"
        >
          Install Metamask or use a Web3-enabled browser to continue.
        </a>
        <div className="d-flex align-items-center ms-lg-4">
          <a href="https://twitter.com/SourPupNFTs" className="btn">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="24"
              height="24"
              viewBox="0 0 512 512"
              fill="currentColor"
            >
              <path d="M389.2 48h70.6L305.6 224.2 487 464H345L233.7 318.6 106.5 464H35.8L200.7 275.5 26.8 48H172.4L272.9 180.9 389.2 48zM364.4 421.8h39.1L151.1 88h-42L364.4 421.8z" />
            </svg>
          </a>
          <a href="https://opensea.io/collection/sourpups" className="btn">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="24"
              height="24"
              viewBox="0 0 24 24"
              fill="currentColor"
              className="bi bi-discord"
            >
              <title>OpenSea</title>
              <path d="M12 0C5.374 0 0 5.374 0 12s5.374 12 12 12 12-5.374 12-12S18.629 0 12 0ZM5.92 12.403l.051-.081 3.123-4.884a.107.107 0 0 1 .187.014c.52 1.169.972 2.623.76 3.528-.088.372-.335.876-.614 1.342a2.405 2.405 0 0 1-.117.199.106.106 0 0 1-.09.045H6.013a.106.106 0 0 1-.091-.163zm13.914 1.68a.109.109 0 0 1-.065.101c-.243.103-1.07.485-1.414.962-.878 1.222-1.548 2.97-3.048 2.97H9.053a4.019 4.019 0 0 1-4.013-4.028v-.072c0-.058.048-.106.108-.106h3.485c.07 0 .12.063.115.132-.026.226.017.459.125.67.206.42.636.682 1.099.682h1.726v-1.347H9.99a.11.11 0 0 1-.089-.173l.063-.09c.16-.231.391-.586.621-.992.156-.274.308-.566.43-.86.024-.052.043-.107.065-.16.033-.094.067-.182.091-.269a4.57 4.57 0 0 0 .065-.223c.057-.25.081-.514.081-.787 0-.108-.004-.221-.014-.327-.005-.117-.02-.235-.034-.352a3.415 3.415 0 0 0-.048-.312 6.494 6.494 0 0 0-.098-.468l-.014-.06c-.03-.108-.056-.21-.09-.317a11.824 11.824 0 0 0-.328-.972 5.212 5.212 0 0 0-.142-.355c-.072-.178-.146-.339-.213-.49a3.564 3.564 0 0 1-.094-.197 4.658 4.658 0 0 0-.103-.213c-.024-.053-.053-.104-.072-.152l-.211-.388c-.029-.053.019-.118.077-.101l1.32.357h.01l.173.05.192.054.07.019v-.783c0-.379.302-.686.679-.686a.66.66 0 0 1 .477.202.69.69 0 0 1 .2.484V6.65l.141.039c.01.005.022.01.031.017.034.024.084.062.147.11.05.038.103.086.165.137a10.351 10.351 0 0 1 .574.504c.214.199.454.432.684.691.065.074.127.146.192.226.062.079.132.156.19.232.079.104.16.212.235.324.033.053.074.108.105.161.096.142.178.288.257.435.034.067.067.141.096.213.089.197.159.396.202.598a.65.65 0 0 1 .029.132v.01c.014.057.019.12.024.184a2.057 2.057 0 0 1-.106.874c-.031.084-.06.17-.098.254-.075.17-.161.343-.264.502-.034.06-.075.122-.113.182-.043.063-.089.123-.127.18a3.89 3.89 0 0 1-.173.221c-.053.072-.106.144-.166.209-.081.098-.16.19-.245.278-.048.058-.1.118-.156.17-.052.06-.108.113-.156.161-.084.084-.15.147-.208.202l-.137.122a.102.102 0 0 1-.072.03h-1.051v1.346h1.322c.295 0 .576-.104.804-.298.077-.067.415-.36.816-.802a.094.094 0 0 1 .05-.03l3.65-1.057a.108.108 0 0 1 .138.103z" />
            </svg>
          </a>
          <a href="https://discord.gg/8NprDwRf2n" className="btn">
            <i className="bi bi-discord"></i>
          </a>
        </div>
      </div>
    )}
  </React.StrictMode>
);
